
function add(s1, s2) {
    return s1+s2;
}

function isSameRect({rc1, rc2, tolerance=0.01}) {
    if (
      Math.abs(rc1.top - rc2.top) < tolerance &&
      Math.abs(rc1.left - rc2.left) < tolerance &&
      Math.abs(rc1.right - rc2.right) < tolerance &&
      Math.abs(rc1.bottom - rc2.bottom) < tolerance
    ) {
      return true;
    }
    return false;
}


function isSameRects({rcs, qps, tolerance=0.01}) {
  const rcsLength = rcs.length, qpsLength = qps.length;
  if (rcsLength != qpsLength) return false;

  for (let i = 0; i < rcsLength; i++) {
    let xList = [], yList = [];
    let qpLength = qps[i].length;

    for (let j = 0; j < qpLength; j++) {
      xList.push(qps[i][j].x)
      yList.push(qps[i][j].y)
    }
    const rc2 = {
      bottom: Math.min.apply(null,yList),
      left: Math.min.apply(null,xList),
      right: Math.max.apply(null,xList),
      top: Math.max.apply(null,yList),
    }

    if (!isSameRect({rc1: rcs[i], rc2, tolerance})) {
      return false
    }
  }

  return true;
}

function isInRect({pt1, rc2, tolerance=0.01}) {
  let rc = {
    left: Math.min(rc2.left, rc2.right),
    right: Math.max(rc2.left, rc2.right),
    top: Math.min(rc2.top, rc2.bottom),
    bottom: Math.max(rc2.top, rc2.bottom),
  }
  if (
    pt1.x >= rc.left &&
    pt1.x <= rc.right &&
    pt1.y >= rc.top &&
    pt1.y <= rc.bottom
  ) {
    return true;
  }
  if(
    (Math.abs(pt1.x - rc.left) < tolerance || Math.abs(pt1.x - rc.right) < tolerance) &&
    (Math.abs(pt1.y - rc.top) < tolerance || Math.abs(pt1.y - rc.bottom) < tolerance)
  ){
    return true;
  }


  return false;
}

export {
    add,
    isSameRect,
    isInRect,
    isSameRects
};